export const paginationI18NPl = {
    prev: "Poprzednie",
    next: "Następne",
    of: "z",
};
